/**
 * Step 2 — report type selection. Cards rendered from reportTypeRegistry;
 * a single entry today, but the pattern scales to future report types.
 */

import { Check } from "@phosphor-icons/react";
import reportTypeRegistry from "../reportTypeRegistry";

function ReportTypeStep({ wiz, canAccessFinance }) {
  const { reportTypeId, selectReportType } = wiz;
  const types = reportTypeRegistry.filter(
    (t) => !t.requiresFinance || canAccessFinance
  );

  return (
    <div className="prw-step-panel">
      <p className="prw-step-hint">בחרו את סוג הדוח להפקה</p>

      <div className="prw-type-list">
        {types.map(({ id, label, description, Icon }) => {
          const isSel = id === reportTypeId;
          return (
            <button
              key={id}
              type="button"
              className={`prw-type-card ${isSel ? "selected" : ""}`}
              onClick={() => selectReportType(id)}
              aria-pressed={isSel}
            >
              <span className="prw-type-icon">
                <Icon size={18} weight={isSel ? "fill" : "regular"} />
              </span>
              <span className="prw-type-text">
                <span className="prw-type-label">{label}</span>
                <span className="prw-type-desc">{description}</span>
              </span>
              {isSel && (
                <Check size={16} weight="bold" className="prw-type-check" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ReportTypeStep;
